import React, { memo } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import SelectMaterial from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";

import { FormControl } from "./styles/Select";

const Select = ({
  optionsList = [],
  descriptionField,
  value,
  label = "",
  setValue,
  onChange = (value) => {
    setValue(value);
  },
  error = false,
  helperText,
  variant = "standard",
  loading,
  ...props
}) => {
  return (
    <>
      <FormControl variant={variant} error={error}>
        <InputLabel>{label}</InputLabel>
        <SelectMaterial
          value={value}
          onChange={onChange}
          InputProps={
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
            </>
          }
        >
          {optionsList.map((item, index) => (
            <MenuItem key={index} value={item}>
              {item[descriptionField]}
            </MenuItem>
          ))}
        </SelectMaterial>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

export default memo(Select);
